import Vue from 'vue'
import router from '../../router'

export default {
  getEventsPlaces ({ commit }, id) {
    return Vue.axios.get(`/events/places`)
    .then(({ data }) => {
      commit('ADD_EVENT_PLACES', data)
      if (!id && data[0]) {
        commit('ADD_EVENT_PLACE', data[0])
      } else if (id) {
        commit('ADD_EVENT_PLACE', data.find(item => item.id === id))
      }
    })
  },
  updateEventCities ({ commit }, cities) {
    commit('UPDATE_EVENTS_PLACES', cities)
    return Vue.axios.put(`/events/places`, { cities })
  },
  addEventCity ({ commit }, name) {
    return Vue.axios.post(`/events/places`, { name })
    .then(({ data }) => {
      commit('ADD_NEW_EVENT_PLACE', data)
    })
  },
  deleteEventCity ({ commit }, id) {
    return Vue.axios.delete(`/events/places/${id}`)
    .then(({ data }) => {
      router.push(`/events/list`)
      commit('DELETE_EVENT_PLACE', id)
    })
  },
  getEventCity ({ commit }, id) {
    return Vue.axios.get(`/events/places/${id}`)
    .then(({ data }) => {
      commit('ADD_EVENT_PLACE', data)
    })
  },
  addNewEvent ({ commit }, data) {
    commit('ADD_NEW_EVENT', data)
    router.push(`/events/event/new`)
  },
  getEvent ({ commit }, id) {
    return Vue.axios.get(`/events/${id}`)
    .then(({ data }) => {
      commit('ADD_EVENT', data)
    })
  },
  deleteEvent ({ commit }, event) {
    return Vue.axios.delete(`/events/${event.id}`)
    .then(() => {
      router.push(`/events/list/${event.eventCity.id}`)
    })
  },
  deleteEventPhoto ({ commit }, id) {
    commit('CHANGE_EVENT_PHOTO', '')
  },
  updateEvent ({ commit }, data) {
    commit('UPDATE_EVENT', data)
  },
  deleteEventItem ({ commit }, id) {
    commit('DELETE_EVENT_ITEM', id)
  },
  loadEventPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/change-photo/${id}`, formData)
    .then(({ data }) => commit('CHANGE_EVENT_PHOTO', data))
  },
  loadSummaryPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/add-summary-photo/${id}`, formData)
    .then(({ data }) => commit('CHANGE_SUMMARY_PHOTO', data))
  },
  addSummaryPhoto ({ commit }, photoData) {
    commit('CHANGE_SUMMARY_PHOTO', photoData)
  },
  deleteSummaryPhoto ({ commit }, photo) {
    commit('DELETE_SUMMARY_PHOTO', photo)
  },
  addEventItem ({ commit }, data) {
    commit('ADD_EVENT_ITEM', data)
  },
  addSpeaker ({ commit }, data) {
    commit('ADD_NEW_SPEAKER', data)
  },
  deleteSpeaker ({ commit }, id) {
    commit('DELETE_SPEAKER', id)
  },
  addSubtitle ({ commit }, data) {
    commit('ADD_NEW_SPEAKER', data)
  },
  loadSpeakerPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/items/speakers/change-photo/${id}`, formData)
  },
  updateEventItem ({ commit }, item) {
    commit('UPDATE_EVENT_ITEM', item)
  },
  saveEvent ({ commit, dispatch }, event) {
    const newPhotos = event.photos.filter(p => typeof p === 'object')
    const speakers = [].concat.apply([], event.eventItems.map(i => i.speakers)).filter(s => s.newPhoto)

    event.photos = event.photos.filter(p => typeof p === 'string')
    return Vue.axios.put(`/events/${event.id}`, { event })
    .then(({ data }) => {
      commit('UPDATE_EVENT', data)
      if (event.newPhoto) {
        return dispatch('loadEventPhoto', { formData: event.newPhoto, id: event.id })
      }
      return true
    })
    .then(() => {
      return newPhotos.reduce(
        (p, v) => p.then((a) => dispatch('loadSummaryPhoto', { formData: v.data, id: event.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
    .then(() => {
      return speakers.reduce(
        (p, v) => p.then((a) => dispatch('loadSpeakerPhoto', { formData: v.newPhoto, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
  },
  updateEventSpeaker ({ commit }, speaker) {
    commit('UPDATE_EVENT_SPEAKER', speaker)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/events.js